<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes=" table-responsive">
            <template slot="header">
             <div class="d-flex align-items-center justify-content-between">
                <h4 class="card-title mb-0"><i class="icon-svg icon-clipboard-list"></i>{{$t('solicitud_documentos')}}</h4>
                <router-link to="plantilla_solicitud" class="btn btn-add-outline btn-sm flex-shrink-0 ml-3">
                  <i class="icon-svg icon-plus"></i> {{$t("nuevo")}}
                </router-link>
             </div>
            </template>
            <l-table class="pl-4 table-hover table-striped"
                     :columns="table.columns"
                     :section="section"
                     @deleteEvent="onDeleteEvent"
                     :data="tableData">
            </l-table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { apiCallList, dataTableLengthMenu, dataTableEsLanguage, enhanceDataTableLength } from '../../mixins'

  const tableColumns = ['id', 'name','actions']
  export default {
    mixins: [apiCallList],
    components: {
     
    },
    data () {
      return {
        table: {
          columns: [...tableColumns],
        },
        section : "plantilla_solicitud",
        tableData : [],
        endpoint : "template_request_documentation",
      }
    },
    methods : {
        loadItems(){           
            this.tableData = this.data;
            setTimeout(() => {
              window.$(".table").dataTable({
                pageLength: 10,
                lengthMenu: dataTableLengthMenu,
                language: dataTableEsLanguage,
                autoWidth: false,
                columnDefs: [{ orderable: false, targets: -1 }]
              });
              enhanceDataTableLength();
            },100);
        },
        onDeleteEvent(item){
          this.$dialog.confirm({
              title: this.$t("deleteTemplate"),
              body: this.$t("deleteTemplateText"),
              okText: this.$t("Aceptar"),
              cancelText: this.$t("Cancelar"),
          },
          { customClass: 'cd-dialog cd-dialog--danger' })
          .then(() => {
              this.$store.dispatch('isLoadingOn');           
              this.$axios.delete("/template_request_documentation/"+item.id)
                .then(() => {
                  this.fetch();
                  this.$store.dispatch('isLoadingOff');           
                })
            })
        }
    }
  }
</script>
<style>
</style>
